// Shared display formatting: USD money and Eastern Time dates (centers are in Newport & Verona, KY).
export const TZ = "America/New_York";
export const TZ_LABEL = "ET";

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const money = (v) => {
  const n = Number(v);
  return usd.format(Number.isFinite(n) ? n : 0);
};

const isDateOnly = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v);
const toDate = (v) => {
  if (v == null || v === "") return null;
  if (isDateOnly(v)) {
    const [y, m, d] = v.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d, 12));
  }
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Calendar date, e.g. "Tue, Jun 9, 2026". Date-only strings are treated as local center dates.
export const fmtDate = (v, opts = {}) => {
  const d = toDate(v);
  if (!d) return "";
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric", timeZone: isDateOnly(v) ? "UTC" : TZ, ...opts });
};

// "HH:MM" wall-clock (center local) → "6:00 PM".
export const fmtClock = (hhmm) => {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ""));
  if (!m) return "";
  const h = Number(m[1]);
  return `${h % 12 || 12}:${m[2]} ${h < 12 ? "AM" : "PM"}`;
};

// Start/end wall-clock range with timezone, e.g. "6:00 PM – 8:00 PM ET".
export const fmtTimeRange = (start, end) => {
  const s = fmtClock(start);
  if (!s) return "";
  const e = fmtClock(end);
  return `${s}${e ? ` – ${e}` : ""} ${TZ_LABEL}`;
};

// Full timestamp in ET, e.g. "Jun 9, 2026, 6:00 PM ET".
export const fmtDateTime = (v) => {
  const d = toDate(v);
  if (!d) return "";
  if (isDateOnly(v)) return fmtDate(v);
  return `${d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZone: TZ })} ${TZ_LABEL}`;
};

const PLACEHOLDER = /^(description( here)?|tbd|todo|coming soon|lorem ipsum.*|n\/?a|test|placeholder|add (a )?description.*|\.+|-+)$/i;
export const hasRealDescription = (text) => {
  const t = String(text || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return t.length >= 12 && !PLACEHOLDER.test(t);
};
